export { getShippingDeliveryStarterSteps } from './shipping-delivery-starter.tour';
export { getShippingDeliveryEnterpriseSteps } from './shipping-delivery-enterprise.tour';
export { getShippingCostSteps } from './shipping-cost.tour';
export { getShippingCostStarterSteps } from './shipping-cost-starter.tour';
export { getPaymentApiSteps } from './payment-api.tour';
export { getQrislyApiSteps } from './qrisly-api.tour';

export function cleanUpAllTourStates(): void {
  if ((window as any).__tourClickBlocker) {
    document.removeEventListener('click', (window as any).__tourClickBlocker, true);
    delete (window as any).__tourClickBlocker;
  }
  if ((window as any).__tourClickBlockerDoc) {
    document.removeEventListener('click', (window as any).__tourClickBlockerDoc, true);
    document.removeEventListener('mousedown', (window as any).__tourClickBlockerDoc, true);
    document.removeEventListener('keydown', (window as any).__tourClickBlockerDoc, true);
    delete (window as any).__tourClickBlockerDoc;
  }
  if ((window as any).__tourClickBlockerCard) {
    document.removeEventListener('click', (window as any).__tourClickBlockerCard, true);
    document.removeEventListener('mousedown', (window as any).__tourClickBlockerCard, true);
    document.removeEventListener('keydown', (window as any).__tourClickBlockerCard, true);
    delete (window as any).__tourClickBlockerCard;
  }
  document.documentElement.style.overscrollBehavior = '';
  document.documentElement.style.overscrollBehaviorX = '';
  document.body.style.overscrollBehavior = '';
  document.body.style.overscrollBehaviorX = '';

  if ((window as any).__tourKeyBlocker) {
    window.removeEventListener('keydown', (window as any).__tourKeyBlocker, true);
    window.removeEventListener('keyup', (window as any).__tourKeyBlocker, true);
    delete (window as any).__tourKeyBlocker;
  if ((window as any).__tourRouterSubscription) {
    (window as any).__tourRouterSubscription.unsubscribe();
    delete (window as any).__tourRouterSubscription;
  }
  delete (window as any).__tourCurrentUrl;
  delete (window as any).__tourCurrentRouteUrl;
  if ((window as any).__tourPopstateHandler) {
    window.removeEventListener('popstate', (window as any).__tourPopstateHandler);
    delete (window as any).__tourPopstateHandler;
  }
  if ((window as any).__tourPushCount) {
    const count = (window as any).__tourPushCount;
    delete (window as any).__tourPushCount;
    try {
      history.go(-count);
    } catch (e) {}
  }
  if ((window as any).__tourAuxClickHandler) {
    window.removeEventListener('auxclick', (window as any).__tourAuxClickHandler, true);
    window.removeEventListener('pointerdown', (window as any).__tourAuxClickHandler, true);
    window.removeEventListener('mousedown', (window as any).__tourAuxClickHandler, true);
    delete (window as any).__tourAuxClickHandler;
  }
  if ((window as any).__tourWheelHandler) {
    window.removeEventListener('wheel', (window as any).__tourWheelHandler, true);
    delete (window as any).__tourWheelHandler;
  }
  if ((window as any).__tourTouchHandler) {
    window.removeEventListener('touchstart', (window as any).__tourTouchHandler.handleTouchStart, true);
    window.removeEventListener('touchmove', (window as any).__tourTouchHandler.handleTouchMove, true);
    delete (window as any).__tourTouchHandler;
  }
  delete (window as any).__passwordVerifiedForTour;
  if ((window as any).__docStepResizeObserver) {
    (window as any).__docStepResizeObserver.disconnect();
    delete (window as any).__docStepResizeObserver;
  }

  const blocker = document.getElementById('tour-blocking-overlay');
  if (blocker) {
    blocker.remove();
  }

  const dropProfile = document.querySelector('.drop-profile') as HTMLElement;
  if (dropProfile) {
    dropProfile.classList.remove('show');
    dropProfile.style.display = '';
    dropProfile.style.zIndex = '';
    dropProfile.style.pointerEvents = '';
    const allInteractive = dropProfile.querySelectorAll<HTMLElement>('button, input, a, div, span, img, hr');
    allInteractive.forEach(child => {
      child.style.pointerEvents = '';
      child.style.cursor = '';
    });
  }
  const container = document.querySelector('#profile-dropdown-container') as HTMLElement;
  if (container) {
    container.style.zIndex = '';
    container.style.position = '';
    container.style.pointerEvents = '';
  }
  const dropdownContent = document.querySelector('#profile-dropdown-content') as HTMLElement;
  if (dropdownContent) {
    dropdownContent.style.pointerEvents = '';
  }
  const switchMode = document.querySelector('#switchMode') as HTMLElement;
  if (switchMode) {
    switchMode.style.pointerEvents = '';
    switchMode.style.cursor = '';
  }

  const disabledElements = document.querySelectorAll<HTMLElement>(
    'app-referrer nz-card, app-payment-service-document, app-qrisly-service-doc, app-shipping-delivery, app-webhook-qrisly, app-api-usage, #api-payment-api, #api-qrisly-api, #api-shipping-cost, #api-shipping-delivery'
  );
  disabledElements.forEach(el => {
    el.style.pointerEvents = '';
    const images = el.querySelectorAll('img');
    images.forEach(img => {
      img.style.pointerEvents = '';
      img.style.cursor = '';
    });
  });
}
}
